import { ActionIcon, Button, Checkbox, Group, Modal, Text, UnstyledButton } from '@mantine/core';
import { showNotification } from '@mantine/notifications';
import React, { useEffect } from 'react';
import { FaPen, FaPlus, FaSearch, FaTrash } from 'react-icons/fa';
import InputField, { InputFieldTypes } from '../components/input_field';
import SimpleHeader from '../components/simple_header';
import Table from '../components/table';
import { useApp } from '../contexts/app.context';
import { DELETE_HOLIDAY, GET_ALL_HOLIDAYS, SAVE_HOLIDAY } from '../services/holidays';
import moment from 'moment';
import axios from 'axios';

export default function HolidaysPage(){
    const [items, setItems] = React.useState<any[]>([]);
    const [modal, setModal] = React.useState<any>(null);
    const [modalImport, setModalImport] = React.useState<any>(null);
    const [loadingItems, setLoadingItems] = React.useState<boolean>(false);
    const [loadingDelete, setLoadingDelete] = React.useState({});

    const app = useApp();

    const loadItems = () => {
        setLoadingItems(true)
        GET_ALL_HOLIDAYS()
        .then(res => {
            setItems(res);
            setLoadingItems(false)
        })
        .catch(err => {
            setLoadingItems(false)
            showNotification({title: "Ops", message: err.message, color: 'red'})
        })
    }
    
    const deleteItem = (holidayId) => {
        setLoadingDelete(ld => ({...ld, [`${holidayId}`]: true}))
        DELETE_HOLIDAY(holidayId)
        .then(res => {
            setLoadingDelete(ld => ({...ld, [`${holidayId}`]: false}))
            loadItems()
        })
        .catch(err => {
            setLoadingDelete(ld => ({...ld, [`${holidayId}`]: false}))
            showNotification({title: "Ops", message: err.message, color: 'red'})
        })
    }

    useEffect(loadItems, []);

    return <>
        <SimpleHeader title="Feriados" buttons={[
            { leftIcon: <FaPlus />, title: "Adicionar", onClick: () => { setModal(true)} },
            { leftIcon: <FaPlus />, title: "Importar", onClick: () => { setModalImport(true)} },
        ]}  />
        
        <Table
            data={items}
            loading={loadingItems}
            columns={[
                { key: "title", title: "Título" },
                { key: "period", title: "Período", render: (item) => (
                    item.period[0] !== item.period[1]
                    ? `${moment(item.period[0]).format("DD/MM/YYYY")} à ${moment(item.period[1]).format("DD/MM/YYYY")}`
                    : moment(item.period[0]).format("DD/MM/YYYY")
                ) },
            ]}
            actions={[
                {
                    color: "red",
                    leftIcon: <FaTrash />,
                    title: "Deletar",
                    loading: item => Boolean(loadingDelete[item._id]), 
                    onClick: ({item}) => {
                        app.confirmDialog(
                            {text: "Realmente deseja deletar?"},
                            (({confirmed}) => {
                                if(confirmed) deleteItem(item._id);
                            })
                        )
                    }
                },
                {
                    color: "blue",
                    title: "Editar",
                    leftIcon: <FaPen />,
                    onClick: ({item}) => { setModal(item); }
                },
            ]}
        />

        <HolidayModal
            data={modal}
            opened={!!modal}
            onClose={() => setModal(null)}
            onSave={() => { loadItems(); setModal(null) }}
        />
        
        <HolidayModalImport
            opened={!!modalImport}
            onClose={() => setModalImport(null)}
            onSave={() => { loadItems(); setModalImport(null) }}
        />
    </>
}

const HolidayModal = (props) => {
    const { data : dataParent = null, onClose, onSave, opened = false } = props;
    const [loadingSave, setLoadingSave] = React.useState<boolean>(false);
    const [data, setData] = React.useState<any>(null);

    const handleChange = dt => setData(d => ({...d, ...dt}));

    const handleSave = () => {
        setLoadingSave(true)
        SAVE_HOLIDAY({ ...data, id: dataParent?._id })
        .then(() => {
            setLoadingSave(false)
            onSave && onSave();
        })
        .catch(err => {
            setLoadingSave(false)
            showNotification({title: "Ops", message: err.message, color: 'red'})
        })
    }

    useEffect(() => {
        if(opened) setData({...dataParent})
    }, [opened, dataParent])

    return <>
        <Modal
            opened={!!opened}
            onClose={onClose}
            size="md"
            styles={{content: {minHeight: 500}}}
        >
            <InputField
                mb="lg"
                name="title"
                title="Título"
                value={data?.title}
                onChange={handleChange}
            />
            <InputField
                mb="lg"
                name="period"
                title="Período"
                fieldType={InputFieldTypes.DATERANGE}
                value={(data?.period ?? []).map(p => p ? moment(p).toDate() : p)}
                onChange={handleChange}
            />

            <Group position='right'>
                <Button variant='subtle' disabled={loadingSave} onClick={onClose}>Cancelar</Button>
                <Button variant='filled' loading={loadingSave} onClick={handleSave}>Salvar</Button>
            </Group>
        </Modal>
    </>
}

const HolidayModalImport = (props) => {
    const { onClose, onSave, opened = false } = props;
    const [loadingSave, setLoadingSave] = React.useState<boolean>(false);
    const [items, setItems] = React.useState<any[]>([]);
    const [year, setYear] = React.useState<number>(moment().year());

    const loadItems = () => {
        axios.get(`https://brasilapi.com.br/api/feriados/v1/${year}`)
        .then(({data}) => {
            setItems(data.map(d => ({...d, checked: true})));
        })
        .catch(err => {
            setLoadingSave(false)
            showNotification({title: "Ops", message: err.message, color: 'red'})
        })
    };

    const handleSave = async () => {
        setLoadingSave(true)
        for(let item of items){
            await new Promise((resolve, reject) => {
                SAVE_HOLIDAY({ title: item.name, period: [item.date, item.date] })
                .then(resolve)
                .catch(err => {
                    showNotification({title: "Ops", message: `Falha ao cadastrar - ${item.name}`, color: 'red'})
                    resolve(false)
                })
            })
        }
        setLoadingSave(false)
        onSave && onSave();
    }

    useEffect(() => {
        if(opened) loadItems()
    }, [opened])

    return <>
        <Modal
            opened={!!opened}
            onClose={onClose}
            size="md"
            styles={{content: {minHeight: 500}}}
        >
            <Group>
                <InputField
                    mb="lg"
                    name="y"
                    title="Ano"
                    style={{ flex: 1 }}
                    fieldType={InputFieldTypes.NUMBER}
                    value={year}
                    onChange={({y}) => setYear(y)}
                />
                <ActionIcon size="lg" color="orange" variant='light' onClick={loadItems}><FaSearch /></ActionIcon>
            </Group>
            {items.map((item, i) => <UnstyledButton
                style={{width: '100%'}}
                mb="md"
                onClick={() => setItems(its => its.map((it, j) => i === j ? {...it, checked: !it.checked} : it))}
            >
                <Group>
                    <Checkbox checked={item.checked} />
                    <div style={{flex: 1}}>
                        <Text size="lg">{item.name}</Text>
                        <Text size="sm">{moment(item.date).format("DD/MM/YYYY")}</Text>
                    </div>
                </Group>
            </UnstyledButton>)}

            <Group position='right'>
                <Button variant='subtle' disabled={loadingSave} onClick={onClose}>Cancelar</Button>
                <Button variant='filled' loading={loadingSave} onClick={handleSave}>Salvar</Button>
            </Group>
        </Modal>
    </>
}
